import { useWallet } from "@solana/wallet-adapter-react";
import React, { useContext } from "react";
import noNotifications from "../../../assets/noNotifications.svg";
import notificationPending from "../../../assets/pendingNotification.svg";

import { UserContext } from "../../../contexts/userContext";
import Notifications from "../Notifications/Notifications";
import "./NotificationWrapper.scss";

const Navbar: React.FC = () => {
  const wallet = useWallet();

  const {
    notifications,
    isNotificationsModalVisible,
    toggleNotificationsModal,
  } = useContext(UserContext);

  const notificationsIcon = notifications?.find((n) => !n.hasRead)
    ? notificationPending
    : noNotifications;

  return (
    <div className="notification-component">
      <div className="notification-component__option">
        {wallet.publicKey && (
          <img
            src={notificationsIcon}
            alt="Notifications"
            onClick={() =>
              toggleNotificationsModal(!isNotificationsModalVisible)
            }
          />
        )}

        {isNotificationsModalVisible && (
          <>
            <div
              className="notification-component-wrapper"
              onClick={() =>
                toggleNotificationsModal(!isNotificationsModalVisible)
              }
            ></div>
            <Notifications />
          </>
        )}
      </div>
    </div>
  );
};

export default Navbar;
